var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.fullscreenLoading),expression:"fullscreenLoading"}],staticClass:"background-info"},[_c('img',{staticStyle:{"margin-top":"15%","height":"40%","width":"100%","left":"0"},attrs:{"src":"/static/img/waitingNew.svg"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11eb266b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/public/publicMask.vue
// module id = null
// module chunks = 